<template>
  <SectionContentBadgeImageTextSplit v-bind="props" />
</template>

<script setup>
const props = defineProps({
  badgeText: {
    type: String,
    default: 'Scans and Tests Focus'
  },
  title: {
    type: String,
    default: 'Coronary Calcium Scan'
  },
  content: {
    type: String,
    default: `<p>You know the saying… "An ounce of prevention is worth a pound of cure."</p>
<p>And, this is essentially what a coronary calcium scan is.</p>
<p>This type of scan is basically a CT scan of your heart aimed at detecting early plaque buildup and producing a score which indicates your personal risk of heart attack.</p>
<p>Scans like this can provide you with the information you need to fine tune your diet and exercise regimen, also helping you navigate any changes or tweaks you may need to make to ensure your heart is healthy, gets healthy, and/or remains healthy.<sup>13</sup></p>`
  },
  imageSrc: {
    type: String,
    default: 'assets/images/Coronary-mens.jpg'
  },
  imageAlt: {
    type: String,
    default: 'Coronary calcium scan on a medical monitor'
  },
  imagePosition: {
    type: String,
    default: 'left'
  },
  contentGap: {
    type: String,
    default: 'large'
  },
  showDivider: {
    type: Boolean,
    default: true
  },
  paddingTop: {
    type: String,
    default: 'default'
  },
  paddingBottom: {
    type: String,
    default: 'default'
  }
})

defineBuilderComponent({
  friendlyName: 'Content - Split Coronary Scan',
  inputs: [
    {
      name: 'badgeText',
      type: 'text',
      defaultValue: 'Scans and Tests Focus'
    },
    {
      name: 'title',
      type: 'richText',
      defaultValue: 'Coronary Calcium Scan'
    },
    {
      name: 'content',
      type: 'richText',
      defaultValue: `<p>You know the saying… "An ounce of prevention is worth a pound of cure."</p>
<p>And, this is essentially what a coronary calcium scan is.</p>
<p>This type of scan is basically a CT scan of your heart aimed at detecting early plaque buildup and producing a score which indicates your personal risk of heart attack.</p>
<p>Scans like this can provide you with the information you need to fine tune your diet and exercise regimen, also helping you navigate any changes or tweaks you may need to make to ensure your heart is healthy, gets healthy, and/or remains healthy.<sup>13</sup></p>`
    },
    {
      name: 'imageSrc',
      type: 'file',
      allowedFileTypes: ['jpeg', 'jpg', 'png', 'webp'],
      defaultValue: 'assets/images/Coronary-mens.jpg'
    },
    {
      name: 'imageAlt',
      type: 'text',
      defaultValue: 'Coronary calcium scan on a medical monitor'
    },
    {
      name: 'imagePosition',
      type: 'text',
      enum: ['left', 'right'],
      defaultValue: 'left'
    },
    {
      name: 'contentGap',
      type: 'text',
      enum: ['large', 'medium'],
      defaultValue: 'large'
    },
    {
      name: 'showDivider',
      type: 'boolean',
      defaultValue: true
    },
    {
      name: 'paddingTop',
      type: 'text',
      enum: ['default', 'reduced'],
      defaultValue: 'default'
    },
    {
      name: 'paddingBottom',
      type: 'text',
      enum: ['default', 'reduced'],
      defaultValue: 'default'
    }
  ]
})
</script>
